/* eslint-disable max-params */
/**
 *
 * @param {string[]} charactersToFilter An array of characters to filter from
 * @returns [string] the filtered array including only 0~9 characters
 */
export const filterNumbersOnly = (charactersToFilter: string[]): string[] =>
  charactersToFilter.filter((char) => char >= '0' && char <= '9');
